import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import Spinner from 'components/Shared/Spinner';
import ErrorIcon from 'assets/img/icon-error.svg';
import AlertModal from './AlertModal';

const InfoSavedWorksheetModal = props => {
  const { t } = useTranslation(['create-assign-question']);
  const history = useHistory();
  const { isShow, onConfirm, onClose, error, onCloseError, isLoading } = props;
  const buttons = (
    <>
      {error && (
        <button
          type="button"
          className="btn btn-primary"
          onClick={onCloseError}
        >
          {t(`create-assign-question:saveWoModal.close`, 'Close')}
        </button>
      )}
      {!error && !isLoading && (
        <>
          <button type="button" className="btn btn-primary" onClick={onConfirm}>
            {t(
              `create-assign-question:saveWoModal.wantAssign`,
              'I want to assign now'
            )}
          </button>
          <button
            type="button"
            className="btn btn-outline-light"
            onClick={onClose}
          >
            {t(`create-assign-question:saveWoModal.no`, 'No')}
          </button>
        </>
      )}
    </>
  );

  const errorTitle = (
    <p style={{ textAlign: 'center', color: '#000000' }}>
      <span>
        <img
          src={ErrorIcon}
          alt="error"
          style={{
            width: '40px',
            marginRight: '20px',
            marginBottom: '5px'
          }}
        />
        {t(`create-assign-question:saveWoModal.no`, 'Error')}
      </span>
    </p>
  );

  return (
    <AlertModal
      title={
        isLoading
          ? t(`create-assign-question:saveWoModal.savingWo`, 'Saving Worksheet')
          : error === null
          ? t(
              `create-assign-question:saveWoModal.woSaved`,
              'Worksheet Saved Successfully!'
            )
          : errorTitle
      }
      isShow={isShow}
      handleClose={onClose}
      buttons={buttons}
    >
      <div className="custom-popups__saved-only">
        {isLoading && <Spinner />}
        {!isLoading && error === null && (
          <>
            <p>
              {t(
                `create-assign-question:saveWoModal.woSavedMsg`,
                'Your Worksheet has been saved succesfully'
              )}
            </p>
            <ul>
              <li className="custom-popups-list">
                {t(
                  `create-assign-question:saveWoModal.findWo`,
                  'find your worksheet at'
                )}
                <button
                  type="button"
                  className="btn btn-link"
                  onClick={() =>
                    history.push('/create-and-assign/saved-worksheet')
                  }
                  style={{ width: '100%' }}
                >
                  <i className="icon-saved" />
                  {t(
                    `create-assign-question:saveWoModal.savedWo`,
                    'Saved Worksheet'
                  )}
                </button>
              </li>
            </ul>
            <p>
              {t(
                `create-assign-question:saveWoModal.assignWo`,
                'Do you want to assign worksheet now?'
              )}
            </p>
          </>
        )}
        {!isLoading && error !== null && (
          <>
            <p
              style={{
                textAlign: 'center',
                marginTop: '15px',
                color: '#000000',
                marginBottom: '20px',
                fontWeight: 'normal'
              }}
            >
              {error}
              <br />{' '}
              {t(
                `create-assign-question:saveAssignModal.tryAgain`,
                'Please try again.'
              )}
            </p>
          </>
        )}
      </div>
    </AlertModal>
  );
};

export default InfoSavedWorksheetModal;
